import React from 'react';

var ListItemWithImageComponent = function (_a) {
    var imageSrc = _a.imageSrc, odd = _a.odd, _b = _a.haveSkeleton, haveSkeleton = _b === void 0 ? false : _b, _c = _a.forFishingEmpty, forFishingEmpty = _c === void 0 ? false : _c, _d = _a.forFishingEmptyActive, forFishingEmptyActive = _d === void 0 ? false : _d;
    return (React.createElement("div", { className: "list-item-result ".concat(haveSkeleton ? "have-skeleton" : "", " ").concat(forFishingEmptyActive ? "active" : "") },
        React.createElement(ListItemWithImage.Image, { imageSrc: imageSrc }),
        !forFishingEmpty && React.createElement(ListItemWithImage.Odd, { odd: odd })));
};
var Image = function (_a) {
    var imageSrc = _a.imageSrc;
    return (React.createElement("div", { className: "list-item-result-left" },
        React.createElement("img", { className: "fish-img", src: imageSrc, alt: "" })));
};
var Odd = function (_a) {
    var odd = _a.odd;
    return (React.createElement("div", { className: "list-item-result-right" },
        React.createElement("span", { className: "result-coefficient-spn" }, odd)));
};
var ListItemWithImage = Object.assign(ListItemWithImageComponent, {
    Image: Image,
    Odd: Odd,
});

export { ListItemWithImage };
